import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { useIntl } from 'react-intl';
import { useStyles } from './SelectCard.styles';
type selectProps = {
  value?: string | number;
  handleChange: (event: any) => void;
  lable?: string;
  fieldName: string;
  OptionsValue?: string[];
  OptionsValueId?: any;
  selected: string | number;
  ClassName?: string;
  placeholder?: string;
  id?: string;
  Textlabel?: string;
  classSelect?: string;
  nameid?: string;
  selctOption?: any
}
export const SelectDropDown = ({ value, handleChange, lable, fieldName, OptionsValue, selected, ClassName, placeholder, id, OptionsValueId, Textlabel, classSelect, nameid, selctOption }: selectProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  return (
    <FormControl variant='outlined' className={ClassName}>
      {Textlabel ? <label className={classes.lebelText}>
        {formatMessage({ id: `customer.create.${Textlabel}` })}&nbsp;<span style={{ color: 'red' }}>*</span>
      </label> : null}
      <InputLabel htmlFor="outlined-age-native-simple">{value}</InputLabel>
      <Select
        native
        value={selected}
        onChange={handleChange}
        label={lable}
        inputProps={{
          name: fieldName,
          id: 'outlined-age-native-simple',
        }}
        className={classSelect}
      > <option disabled={true} value="" >
          {placeholder}</option>
        {id === "id" ? OptionsValueId?.map((item: any, i: any) => (
          <option key={i} value={item?.id}>{item?.companyName == "allUser" ? formatMessage({ id: 'user.allUser', defaultMessage: "All User" }) : item?.companyName}</option>
        )) : OptionsValue?.map((item: any, i) => (
          <option key={i} value={item}>{item}</option>
        ))
        }
        {nameid === "name" ? selctOption?.map((item: any, i) => (
          <option key={i} value={item}>{item?.name}</option>
        )) : null}
        {nameid === "userId" ? selctOption?.map((item: any, i) => (
          <option key={i} value={item?.id}>{item?.name}</option>
        )) : null}
        {nameid === "firstname" ? selctOption?.map((item: any, i) => (
          <option key={i} value={item?.id}>{item?.firstName}</option>
        )) : null}
      </Select>
    </FormControl>
  )
}